import type { BrokerCommunication } from "@dune/types";
import DOMPurify from "dompurify";
import { createSignatureHtml } from "./signature.utils";

export const createEmailTemplate = (
	action: "reply" | "replyAll" | "forward",
	mail: BrokerCommunication,
	signature?: string,
) => {
	const baseContent = `\n<br/><br/>\n<p>Le ${mail.date}, ${mail.from} a écrit :</p>\n<blockquote style="border-left: 2px solid #e5e7eb; margin: 0; padding-left: 1em; color: #6b7280;">${DOMPurify.sanitize(mail.htmlContent)}</blockquote>`;

	const signatureHtml = signature?.trim()
		? createSignatureHtml(signature, { withDivider: false })
		: "";

	switch (action) {
		case "reply":
			return {
				to: [{ value: mail.from, label: mail.from }],
				cc: [],
				subject: `Re: ${mail.subject}`,
				content: `${signatureHtml}${baseContent}`,
			};
		case "replyAll":
			return {
				to: [{ value: mail.from, label: mail.from }],
				cc: mail.to
					.filter((email: string) => email !== mail.from)
					.map((email: string) => ({ value: email, label: email })),
				subject: `Re: ${mail.subject}`,
				content: `${signatureHtml}${baseContent}`,
			};
		case "forward":
			return {
				to: [],
				cc: [],
				subject: `Fwd: ${mail.subject}`,
				content: `${signatureHtml}\n<br/>\n<p>Le ${mail.date}, ${mail.from} a écrit :</p>\n<blockquote style="border-left: 2px solid #e5e7eb; margin: 0; padding-left: 1em; color: #6b7280;">${DOMPurify.sanitize(mail.htmlContent)}</blockquote>`,
				attachments:
					mail.attachments?.map((att) => ({
						id: crypto.randomUUID(),
						file: new File([], att.fileName, { type: att.contentType }),
						name: att.fileName,
						size: att.size,
						type: att.contentType,
						url: att.url,
						contentType: att.contentType,
						isUploading: false,
					})) || [],
			};
	}
};
